// components/company/tabs/CompanyStatusHistory.jsx

// Lightweight formatting helpers so we don't depend on any extra libs
function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value; // fallback to raw
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
}

function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value; // fallback to raw
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const CompanyStatusHistory = ({ history, error }) => {
  if (error) {
    return (
      <div className="card">
        <p className="error-text">Could not load status history. Please try again later.</p>
      </div>
    );
  }

  if (!history || history.length === 0) {
    return (
      <div className="card">
        <p className="muted">No status changes recorded yet.</p>
      </div>
    );
  }

  return (
    <div className="card">
      <h2 className="card-title">Status History</h2>
      <div className="table-wrapper">
        <table className="table">
          <thead>
            <tr>
              <th>Status</th>
              <th>Effective date</th>
              <th>Reason</th>
              <th>Source</th>
              <th>Recorded at</th>
            </tr>
          </thead>
          <tbody>
            {history.map((row) => (
              <tr key={row.id}>
                <td>{row.status}</td>
                <td>{formatDate(row.effective_date)}</td>
                <td>{row.reason || "—"}</td>
                <td>{row.source || "manual"}</td>
                <td>{formatDateTime(row.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
